import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';

const Navigation = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const drawer = document.querySelector('.drawer');
      if (drawer && !drawer.contains(e.target) && isDrawerOpen) {
        setIsDrawerOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDrawerOpen]);

  return (
    <div className="navigation-container" style={{ backgroundColor: 'white' }}>
      {isDrawerOpen && <div className="overlay" onClick={toggleDrawer}></div>}

      <header className="navbar">
        <img onClick={() => navigate("/booking")} src="/images/CIAL_Logo.png" alt="Logo" className="logo" />
        <h1 className="heading">
          WELCOME TO <span className="cial-highlight">CIAL</span> ONLINE TAXI BOOKING
        </h1>
        <FaBars className="hamburger-icon" onClick={(e) => { e.stopPropagation(); toggleDrawer(); }} />
      </header>



      <div className={`drawer ${isDrawerOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
        <img src="/images/CIAL_White_Logo.png" alt="Logo" className="drawer-logo" />
        <button className="close-drawer" onClick={toggleDrawer} aria-label="Close Drawer">
          ✕
        </button>
        <ul className="drawer-menu">
          <li onClick={() => navigate("/transaction-details")}>TRANSACTION DETAILS</li>
          <li onClick={() => navigate("/journey")}>UPCOMING JOURNEY</li>
          <li onClick={() => navigate("/faq")}>FAQ</li>
          <li onClick={() => {
            localStorage.clear();
            sessionStorage.clear();
            navigate("/")
          }}>LOG OUT</li>
        </ul>
      </div>
    </div>
  );
};

export default Navigation;
